import React, { createContext, useContext, memo, forwardRef } from "react";
import { useBuildingDetail } from "./BuildingDetailContext";

interface IBuildingDetailUnidContext {
  nameUnit: string;
  indexUnit: number;
  nameBuildingUnit: string;
  nameBuilding: string;
}

const BuildingDetailUnidContext = createContext<IBuildingDetailUnidContext>(
  {} as IBuildingDetailUnidContext
);

interface BuildingDetailUnidContextProviderProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  indexUnit: number;
  uuid: string;
}

const BuildingDetailUnidContextProviderInner = forwardRef<
  HTMLDivElement,
  BuildingDetailUnidContextProviderProps
>(({ children, indexUnit, uuid, ...rest }, ref) => {
  const { nameBuildingUnits: nameBuildingUnit, nameBuilding } = useBuildingDetail();

  const values = {
    nameUnit: `${nameBuildingUnit}.${indexUnit}`,
    indexUnit,
    nameBuildingUnit,
    nameBuilding
  };

  return (
    <div ref={ref} {...rest}>
      <BuildingDetailUnidContext.Provider value={values}>
        {children}
      </BuildingDetailUnidContext.Provider>
    </div>
  );
});

BuildingDetailUnidContextProviderInner.displayName =
  "BuildingDetailUnidContextProvider";

export const BuildingDetailUnidContextProvider = memo(
  BuildingDetailUnidContextProviderInner,
  (prevProps, nextProps) =>
    prevProps.indexUnit === nextProps.indexUnit && prevProps.uuid === nextProps.uuid
);

export const useBuildingDetailUnidContext = () =>
  useContext(BuildingDetailUnidContext);
